 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		2: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"common","12":"stencil-ion-action-sheet-ios-entry-js","13":"stencil-ion-action-sheet-md-entry-js","14":"stencil-ion-alert-ios-entry-js","15":"stencil-ion-alert-md-entry-js","16":"stencil-ion-app_8-ios-entry-js","17":"stencil-ion-app_8-md-entry-js","18":"stencil-ion-avatar_3-ios-entry-js","19":"stencil-ion-avatar_3-md-entry-js","20":"stencil-ion-back-button-ios-entry-js","21":"stencil-ion-back-button-md-entry-js","22":"stencil-ion-backdrop-ios-entry-js","23":"stencil-ion-backdrop-md-entry-js","24":"stencil-ion-button_2-ios-entry-js","25":"stencil-ion-button_2-md-entry-js","26":"stencil-ion-card_5-ios-entry-js","27":"stencil-ion-card_5-md-entry-js","28":"stencil-ion-checkbox-ios-entry-js","29":"stencil-ion-checkbox-md-entry-js","30":"stencil-ion-chip-ios-entry-js","31":"stencil-ion-chip-md-entry-js","32":"stencil-ion-col_3-entry-js","33":"stencil-ion-datetime_3-ios-entry-js","34":"stencil-ion-datetime_3-md-entry-js","35":"stencil-ion-fab_3-ios-entry-js","36":"stencil-ion-fab_3-md-entry-js","37":"stencil-ion-img-entry-js","38":"stencil-ion-infinite-scroll_2-ios-entry-js","39":"stencil-ion-infinite-scroll_2-md-entry-js","40":"stencil-ion-input-ios-entry-js","41":"stencil-ion-input-md-entry-js","42":"stencil-ion-item-option_3-ios-entry-js","43":"stencil-ion-item-option_3-md-entry-js","44":"stencil-ion-item_8-ios-entry-js","45":"stencil-ion-item_8-md-entry-js","46":"stencil-ion-loading-ios-entry-js","47":"stencil-ion-loading-md-entry-js","48":"stencil-ion-menu_3-ios-entry-js","49":"stencil-ion-menu_3-md-entry-js","50":"stencil-ion-modal-ios-entry-js","51":"stencil-ion-modal-md-entry-js","52":"stencil-ion-nav_2-entry-js","53":"stencil-ion-popover-ios-entry-js","54":"stencil-ion-popover-md-entry-js","55":"stencil-ion-progress-bar-ios-entry-js","56":"stencil-ion-progress-bar-md-entry-js","57":"stencil-ion-radio_2-ios-entry-js","58":"stencil-ion-radio_2-md-entry-js","59":"stencil-ion-range-ios-entry-js","60":"stencil-ion-range-md-entry-js","61":"stencil-ion-refresher_2-ios-entry-js","62":"stencil-ion-refresher_2-md-entry-js","63":"stencil-ion-reorder_2-ios-entry-js","64":"stencil-ion-reorder_2-md-entry-js","65":"stencil-ion-ripple-effect-entry-js","66":"stencil-ion-route_4-entry-js","67":"stencil-ion-searchbar-ios-entry-js","68":"stencil-ion-searchbar-md-entry-js","69":"stencil-ion-segment_2-ios-entry-js","70":"stencil-ion-segment_2-md-entry-js","71":"stencil-ion-select_3-ios-entry-js","72":"stencil-ion-select_3-md-entry-js","73":"stencil-ion-slide_2-ios-entry-js","74":"stencil-ion-slide_2-md-entry-js","75":"stencil-ion-spinner-entry-js","76":"stencil-ion-split-pane-ios-entry-js","77":"stencil-ion-split-pane-md-entry-js","78":"stencil-ion-tab-bar_2-ios-entry-js","79":"stencil-ion-tab-bar_2-md-entry-js","80":"stencil-ion-tab_2-entry-js","81":"stencil-ion-text-entry-js","82":"stencil-ion-textarea-ios-entry-js","83":"stencil-ion-textarea-md-entry-js","84":"stencil-ion-toast-ios-entry-js","85":"stencil-ion-toast-md-entry-js","86":"stencil-ion-toggle-ios-entry-js","87":"stencil-ion-toggle-md-entry-js","88":"stencil-ion-virtual-scroll-entry-js","89":"stencil-polyfills-core-js","90":"stencil-polyfills-css-shim","91":"stencil-polyfills-dom"}[chunkId]||chunkId) + "-es2015." + {"0":"993d526989c714408cd6","1":"ab4fc871cde233ce6965","3":"a5d553b4d5f52fee597a","4":"9b793b45cd344542ff7b","5":"0b58811b61d79b93eca9","6":"09e6fdeec7f167267bef","7":"5eaa59d3a08a159fe86f","8":"9eda33dad8a607949873","12":"db8d44980bfb2279b0e5","13":"45c72a3f3d8e526429dd","14":"6b66669a0c747855a2a6","15":"6b5c951fcda80330cbe8","16":"1ebcce8d281d6ff1c1e3","17":"4ac5e9e3c9ccbc54ebce","18":"f0d8a26003f91f76b776","19":"d7dd66acbf076af8325a","20":"f5dee27fde7b06b1603b","21":"384c867ed2dc485e224d","22":"946f4cd15993255026d8","23":"1b7448ce352ce989dece","24":"686935f1af9bd1b97744","25":"90a27d411d8dc8afa55b","26":"e6b11f9bc9cad99c9fae","27":"53964bf3f773be741cc6","28":"f65cbbe1b9657550b548","29":"6e75114bbc8bb9fcb526","30":"0d6e5239641b69088b4e","31":"94db02174d4ba791014f","32":"cf4987d1f613aeea2df9","33":"35f63b40040ef8f8c3b6","34":"806cd521afcaf31f3561","35":"807d7dcf90b9650d2217","36":"fd6554d2b033e307b87e","37":"a7757e422e324f76520a","38":"08285b6c61c0c48d86da","39":"be4c99268532aad97f6d","40":"e34a3a7594c9b5b467e7","41":"cc8fc3a116f2e7766d61","42":"f499a37bf6cffa464363","43":"2313655d8404367abb1b","44":"ad4b81b5a3b5d2ff91a9","45":"317206d659de9fd675c0","46":"c5cf24993a3d1fb78d79","47":"c8070082fc9be34e08d4","48":"7ebc47af3913762dfe7b","49":"a5ef7a50014699794db9","50":"f4391f78603e62270451","51":"de139c21b8a6448e74a8","52":"d4f664b64f18dcca0045","53":"c5507320d74cfcefec77","54":"72d71f5ef0c39306873d","55":"1e785b21a3fbaaab9d0a","56":"ac38736f905d645d54db","57":"08176b553cfc137a74ac","58":"21db2407eb3bd22e58de","59":"9599cfd1c8ef696e83be","60":"19d7e19c1f02ad11a786","61":"c2d92fc88c15a701329f","62":"0594f368a30ceb665e5f","63":"e45707a8ad91404be727","64":"6596d5993a617f73c954","65":"b19d43d3cb9e1cd174f5","66":"af870d55af47eef8c519","67":"3f3ebec51a395f5f1578","68":"1d0eb7ba0492f6d5bbcd","69":"42bed1306ec715aa5f0a","70":"a869dc08fa9e71115cd5","71":"36cd1ea13f7ee9d14fa0","72":"56019e71bf8b7cf07eb7","73":"757788d6f436ebcdde32","74":"6428c1a03667743303d4","75":"83ca93ff9e2fa9df5867","76":"16c733377b75a75724df","77":"ad9b2ef9f27f81661d41","78":"f09a90b44ef4f4a2381f","79":"3cbf57d29c1b445dd672","80":"a262a557d917d92b4283","81":"5230f07079c2f7b76724","82":"d9ad2d36a0541c56628a","83":"d53985642d344b885f50","84":"694d1d63c331a64a77df","85":"aa98be72a9d44eb44434","86":"5082691bae6838104e74","87":"445358fb3b484ffe19c8","88":"535a7eb1dff436a43333","89":"8c9d8a12d6ebcadb30ae","90":"84c455121d2a812ccdb0","91":"c8a7f88afad5dc9347e0","93":"22dc754763a596811d03","94":"9a4767641f9dc7dba108","95":"58822e1b491662423c04","96":"eab9cd7af7df6606ce4a","97":"92ecca7fe4f234c24044","98":"9a5f3be80cfc4b951129","99":"7877621e7092670ea1dd","100":"cafe84392e72bca307ca","101":"4b0159c03beab77cbc8c","102":"165a0c0fc6086a3c05ba","103":"60755b7c4a87da66af9e","104":"d3c034c1067bb60c7dd0","105":"e3716e986eed817e4709","106":"91d20e35157aef637070"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
